import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { ShowFriendbuyWidget } from 'components/CallToAction/actions';

export class RafNavItem extends Component {
  handleClick = () => {
    segment.track('raf-nav-click', {
      category: 'Refer-a-Friend',
    });
    ga('Refer-a-Friend', 'raf-nav-click');
  };

  render() {
    const { reward, user } = this.props;

    return (
      <li>
        <ShowFriendbuyWidget onClick={this.handleClick} user={user}>
          <FormattedMessage id="header.link.raf" defaultMessage="Get {reward}" values={{ reward }} />
        </ShowFriendbuyWidget>
      </li>
    );
  }
}

RafNavItem.propTypes = {
  reward: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};
